<template>
  <layout>
    <template slot="header">
      About program
    </template>

    <template>
      <v-list data-test="aboutModal">
        <v-subheader class="subtitle-2 primary--text">Application</v-subheader>
        <v-list-item>
          <v-list-item-content>
            PixelAdmin App version
          </v-list-item-content>
          <v-list-item-icon> 3.2.0 ({{ frontVersion }})</v-list-item-icon>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            PixelCore version
          </v-list-item-content>
          <v-list-item-icon v-if="serverVersion">
            {{ serverVersion }}
          </v-list-item-icon>
          <v-list-item-icon v-else>
            <v-progress-circular
              indeterminate
              size="22"
              width="2"
              color="primary"
            ></v-progress-circular>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            PixelCore timezone
          </v-list-item-content>
          <v-list-item-icon v-if="timeZone">
            {{ timeZone }}
          </v-list-item-icon>
          <v-list-item-icon v-else>
            <v-progress-circular
              indeterminate
              size="22"
              width="2"
              color="primary"
            ></v-progress-circular>
          </v-list-item-icon>
        </v-list-item>
        <v-subheader class="subtitle-2 primary--text">Database</v-subheader>
        <v-list-item>
          <v-list-item-content>
            Size
          </v-list-item-content>
          <v-list-item-icon v-if="dbInfo.mediaSize">{{
            dbInfo.dbSize
          }}</v-list-item-icon>
          <v-list-item-icon v-else>
            <v-progress-circular
              indeterminate
              size="22"
              width="2"
              color="primary"
            ></v-progress-circular>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            Media size
          </v-list-item-content>
          <v-list-item-icon v-if="dbInfo.mediaSize">
            {{ dbInfo.mediaSize }}
          </v-list-item-icon>
          <v-list-item-icon v-else>
            <v-progress-circular
              indeterminate
              size="22"
              width="2"
              color="primary"
            ></v-progress-circular>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            History size
          </v-list-item-content>
          <v-list-item-icon v-if="dbInfo.mediaSize">
            {{ dbInfo.historySize }}
          </v-list-item-icon>
          <v-list-item-icon v-else>
            <v-progress-circular
              indeterminate
              size="22"
              width="2"
              color="primary"
            ></v-progress-circular>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            PPS / total for last 10 mins
          </v-list-item-content>
          <v-list-item-icon v-if="dbInfo.mediaSize"
            >{{ dbInfo.pps }} / {{ dbInfo.props10Min }}</v-list-item-icon
          >
          <v-list-item-icon v-else>
            <v-progress-circular
              indeterminate
              size="22"
              width="2"
              color="primary"
            ></v-progress-circular>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            Retention time
          </v-list-item-content>
          <v-list-item-icon v-if="dbInfo.mediaSize">{{
            dbInfo.retention
          }}</v-list-item-icon>
          <v-list-item-icon v-else>
            <v-progress-circular
              indeterminate
              size="22"
              width="2"
              color="primary"
            ></v-progress-circular>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            Version
          </v-list-item-content>
          <v-list-item-icon v-if="dbInfo.mediaSize">{{
            dbInfo.version
          }}</v-list-item-icon>
          <v-list-item-icon v-else>
            <v-progress-circular
              indeterminate
              size="22"
              width="2"
              color="primary"
            ></v-progress-circular>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            TS version
          </v-list-item-content>
          <v-list-item-icon v-if="dbInfo.mediaSize">{{
            dbInfo.tsVersion
          }}</v-list-item-icon>
          <v-list-item-icon v-else>
            <v-progress-circular
              indeterminate
              size="22"
              width="2"
              color="primary"
            ></v-progress-circular>
          </v-list-item-icon>
        </v-list-item>
        <v-subheader class="subtitle-2 primary--text">About us</v-subheader>
        <v-list-item>
          <v-list-item-content>
            <div v-html="aboutInfo"></div>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>

    <template slot="footer">
      <v-spacer />
      <v-btn
        color="primary"
        data-test="closeAbout"
        text
        :loading="false"
        @click.stop="$emit('close')"
      >
        ok
      </v-btn>
    </template>
  </layout>
</template>

<script>
import Layout from '@/layouts/LayoutPopup';
import useAuth from '@/api/auth';
import { computed, onMounted, ref } from '@vue/composition-api';
import appVersion from 'raw-loader!../../../../../VERSION';
import copyToClipboard from '@/utils/copyToClipboard';

export default {
  name: 'about',
  components: {
    Layout
  },
  setup() {
    const {
      getVersion,
      getDatabaseInfo,
      getTimezoneInfo,
      profile
    } = new useAuth();
    const timeZone = ref(0);
    const serverVersion = ref(0);
    const dbInfo = ref({
      timeZone: '',
      mediaSize: '',
      historySize: '',
      version: '',
      tsVersion: ''
    });
    const frontVersion = ref(0);

    const copyText = e => {
      copyToClipboard(e);
    };

    const copyVersion = () => {
      copyText(process.env.VUE_APP_COMMIT_HASH);
    };

    const aboutInfo = computed(
      () =>
        profile.value?.objectProperties?.find(i => i.key === 'aboutInfo')?.value
          ?.content || ''
    );
    onMounted(() => {
      frontVersion.value = appVersion.replace(/[\n\t\r]/g, '');

      getVersion().then(res => {
        serverVersion.value = res.data.getVersion.short;
      });

      getDatabaseInfo().then(res => {
        dbInfo.value = res.data.getDbInfo;
      });

      getTimezoneInfo().then(res => {
        timeZone.value = res.data.getTimezone;
      });
    });

    return {
      serverVersion,
      copyVersion,
      frontVersion,
      dbInfo,
      timeZone,
      aboutInfo
    };
  }
};
</script>
